import Dropdown from 'react-bootstrap/Dropdown'
import InputGroup from 'react-bootstrap/InputGroup'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import React, { useEffect, useState, useRef } from 'react'

const ENDPOINT = process.env.REACT_APP_API_ENDPOINT || '/'

function LabelDropDown (props) {
  const [newLabelName, setNewLabelName] = useState('')

  const handleCreateLabel = (event) => {
    event.preventDefault()
    event.persist()
    const url = ENDPOINT + 'labels'
    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers({
        Authorization: 'Bearer ' + localStorage.getItem('clippingsToken'),
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify({
        Name: newLabelName
      })
    }).then(async response => {
      const data = await response.json()
      const newLabelID = data.labelID
      fetch(url, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: new Headers({
          Authorization: 'Bearer ' + localStorage.getItem('clippingsToken'),
          'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
          ClipID: event.target.getAttribute('data-clipping-id'),
          LabelID: newLabelID
        })
      }).then(async response => {
        await response.json()
      }).catch(error => {
        console.log(error)
      })
    }).catch(error => {
      console.log(error)
    })

    const addNewLabel = (newLabel) => {
      props.clips.map(clip => {
        if (clip.ID === event.target.getAttribute('data-clipping-id')) {
          clip.Labels = [...clip.Labels, newLabel]
        }
      }
      )
      props.setClips([...props.clips])
      props.setLabelCreated(!props.labelCreated)
    }
    addNewLabel(newLabelName)
  }

  const addLabel = (event) => {
    const addNewLabel = (newLabel) => {
      props.clips.map(clip => {
        if (clip.ID === event.target.getAttribute('data-clipping-id')) {
          clip.Labels = [...clip.Labels, newLabel]
        }
      }
      )
      props.setClips([...props.clips])
    }
    addNewLabel(event.target.getAttribute('data-label-name'))

    const url = ENDPOINT + 'labels'
    fetch(url, {
      method: 'PATCH',
      credentials: 'same-origin',
      headers: new Headers({
        Authorization: 'Bearer ' + localStorage.getItem('clippingsToken'),
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify({
        ClipID: (event.target.getAttribute('data-clipping-id')),
        LabelID: (event.target.getAttribute('data-label-id'))
      })
    }).then(async response => {
      await response.json()
    }).catch(error => {
      console.log(error)
    })
  }
  return (
    <>
      <Dropdown>
        <Dropdown.Toggle variant='secondary' id='dropdown-basic' size='sm'>
          Label
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {props.allLabels.map(label => (
            !props.clipLabels.includes(label.Name) &&
              <Dropdown.Item
                onClick={addLabel}
                data-label-id={label.ID}
                data-clipping-id={props.clippingID}
                data-label-name={label.Name}
                key={label.ID}
              >{label.Name}
              </Dropdown.Item>
          ))}
          <Form onSubmit={handleCreateLabel} data-clipping-id={props.clippingID}>
            <InputGroup className='mb-3' onChange={(event) => setNewLabelName(event.target.value)}>
              <Form.Control
                placeholder='Create new label'
                aria-label='label name'
                aria-describedby='basic-addon1'
              />
            </InputGroup>
            <Button variant='primary' type='submit'>
              Add label
            </Button>
          </Form>

        </Dropdown.Menu>
      </Dropdown>
    </>
  )
}

export default LabelDropDown
